import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../reducers'

export const getListUsers = (state: RootState) => state.users.listUsersData
